export type AppGroup = "configuration" | "tools" | "admin";

export interface Skill {
  id: string;
  name: string;
  description: string;
  color: "teal" | "blue" | "purple" | "amber" | "coral" | "pink";
  status: "live" | "ready" | "planned";
  type: "agent" | "skill" | "section";
  group: AppGroup;
  iconPath: string;
  route: string;
}

export const APPS: Skill[] = [
  {
    id: "portals",
    name: "Portals",
    description: "Connect, disconnect, and manage HubSpot portal credentials.",
    color: "coral",
    status: "live",
    type: "section",
    group: "configuration",
    iconPath:
      "M2 4 L14 4 L14 12 L2 12 Z M2 7 L14 7 M5 4 L5 7 M9 4 L9 7 M5 9.5 L9 9.5",
    route: "/portals",
  },
  {
    id: "prompts",
    name: "Prompts",
    description: "Curated prompt library for HubSpot configuration tasks.",
    color: "purple",
    status: "live",
    type: "section",
    group: "configuration",
    iconPath: "M3 2 L13 2 L13 14 L3 14 Z M5 5 L11 5 M5 8 L11 8 M5 11 L9 11",
    route: "/prompts",
  },
  {
    id: "packages",
    name: "Packages",
    description: "Save and deploy reusable HubSpot configuration bundles.",
    color: "teal",
    status: "live",
    type: "section",
    group: "configuration",
    iconPath: "M2 5 L8 2 L14 5 L14 11 L8 14 L2 11 Z M2 5 L8 8 L14 5 M8 8 L8 14",
    route: "/packages",
  },
  {
    id: "my-work",
    name: "My Work",
    description:
      "Today's tasks, calendar, and recent Teamwork comments in one view.",
    color: "coral",
    status: "live",
    type: "skill",
    group: "tools",
    iconPath:
      "M2 3 L14 3 L14 13 L2 13 Z M2 6 L14 6 M5 9 L5 11 M8 8 L8 11 M11 9.5 L11 11",
    route: "/tools/my-work",
  },
  {
    id: "strategy-doc",
    name: "Strategy Doc Generator",
    description:
      "Generate structured strategy documents from client briefs and portal data.",
    color: "blue",
    status: "live",
    type: "agent",
    group: "tools",
    iconPath:
      "M3 1 L3 15 L13 15 L13 4 L10 1 Z M10 1 L10 4 L13 4 M5 7 L11 7 M5 10 L11 10 M5 13 L9 13",
    route: "/tools/strategy-doc",
  },
  {
    id: "teamwork-duplicates",
    name: "Duplicate Time Logs",
    description: "Detect and remove suspected duplicate Teamwork time entries.",
    color: "amber",
    status: "live",
    type: "skill",
    group: "tools",
    iconPath:
      "M8 1 L8 5 M3 3 L5 5 M13 3 L11 5 M1 8 L15 8 M3 12 L8 15 L13 12 M4 8 L4 12 M12 8 L12 12",
    route: "/tools/teamwork-duplicates",
  },
  {
    id: "timesheets",
    name: "Timesheets",
    description:
      "View any team member's Teamwork time logs in a weekly or daily grid.",
    color: "teal",
    status: "live",
    type: "skill",
    group: "tools",
    iconPath:
      "M3 2 L13 2 L13 14 L3 14 Z M3 5 L13 5 M5 8 L11 8 M5 11 L9 11 M6 2 L6 4 M10 2 L10 4",
    route: "/tools/timesheets",
  },
  {
    id: "workflows",
    name: "Workflows",
    description: "Visual canvas to plan and document HubSpot workflows.",
    color: "pink",
    status: "live",
    type: "agent",
    group: "tools",
    iconPath:
      "M3 3 L6 3 L6 6 L3 6 Z M10 3 L13 3 L13 6 L10 6 Z M3 10 L6 10 L6 13 L3 13 Z M10 10 L13 10 L13 13 L10 13 Z M6 4.5 L10 4.5 M4.5 6 L4.5 10 M11.5 6 L11.5 10 M6 11.5 L10 11.5",
    route: "/tools/workflows",
  },
  {
    id: "settings",
    name: "Settings",
    description: "Account preferences and personal Claude Code API keys.",
    color: "blue",
    status: "live",
    type: "section",
    group: "admin",
    iconPath:
      "M8 5.5 A2.5 2.5 0 0 1 8 10.5 A2.5 2.5 0 0 1 8 5.5 Z M8 1 L8 3 M8 13 L8 15 M1 8 L3 8 M13 8 L15 8 M3 3 L4.5 4.5 M11.5 11.5 L13 13 M3 13 L4.5 11.5 M11.5 4.5 L13 3",
    route: "/settings",
  },
];
